import { createRouter, createWebHistory } from 'vue-router';
import { constantRoutes } from './routes/constant';
import { setupGuards } from './guards';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes
});

setupGuards(router);
export default router;
